/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Settings_Files_Active_Filters_TypeInputs */

const es_settings_files_active_filters_type = /** @type {(inputs: Settings_Files_Active_Filters_TypeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tipo: ${i?.type}`)
};

const en_settings_files_active_filters_type = /** @type {(inputs: Settings_Files_Active_Filters_TypeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Type: ${i?.type}`)
};

/**
* | output |
* | --- |
* | "Type: {type}" |
*
* @param {Settings_Files_Active_Filters_TypeInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_active_filters_type = /** @type {((inputs: Settings_Files_Active_Filters_TypeInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Active_Filters_TypeInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_active_filters_type(inputs)
	return en_settings_files_active_filters_type(inputs)
});
export { settings_files_active_filters_type as "settings.files.active_filters.type" }